import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  Text,
  SimpleGrid,
  Box,
  Input,
  FormLabel,Select,
  InputGroup,
  InputLeftAddon,useDisclosure,
  Checkbox,
  

} from '@chakra-ui/react';
import { useState,useEffect } from 'react';
import { IoMdClose } from "react-icons/io";
import axios from 'axios'
import toast from 'react-hot-toast';
import Cookie from 'js-cookie'

const RoomUpdateModal = ({isOpen,onClose,id,customerId,onOpen,setSelectId,data}) => {
    
   // console.log(id,'id')    
    const [selectedFile, setSelectedFile] = useState(null);
    const[newImageURL,setnewImageURL]=useState(null);
    const [uploading, setUploading] = useState(false);
    const [printData,setPrintData]=useState([])
    const [formData,setFormData]=useState({
        roomNo: "",
      description: "",
      category:"",
     ac:"",
      rate: 0,
      sgst: 0,
      cgst: 0,
      image: "",
      pax:'',
      adult:'',
      child:''
       
    
    
    })
    const token=Cookie.get('token')
    
  //  console.log(unique,'unique')
    

   
   
  // console.log(Object.keys(data)+" :"+Object.values(data),'data')
   

    useEffect(() => {
        if (data) {
            setFormData({
                roomNo: data.roomNo || "",
                description: data.description || "",
                category: data.category || "",
                ac: data.ac || "",
                rate: data.rate || 0,
                sgst: data.sgst || 0,
                cgst: data.cgst || 0,
                image: data.image   || "",
                pax: data.pax   || "",
                adult: data.adult   || "",
                child: data.child   || "",
                
            });
        }
    }, [data]);
    const scroll='inside'
   
    const handleInputChange=(e)=>{
     const {name,value}=e.target;
     setFormData({
        ...formData,
       [name] : value 
     })
    }
    const handleFileChange = (event) => {
      setSelectedFile(event.target.files[0]);
     
      
    }
    const fetchData3 = async () => {
      try {
        const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getPrintData/${customerId}`);
        const rooms = response.data;
    
        // Map over rooms and fetch images dynamically
        const updatedRooms = await Promise.all(
          rooms.map(async (room) => {
            if (room.image) {
              const imageResponse = await axios.get(`https://api.hotel.tdrsoftware.in/get-image/${room.image}`, {
                responseType: 'blob', // Assuming image is returned as a blob
              });
    
              // Create a URL for the image blob
              room.imageUrl = URL.createObjectURL(imageResponse.data);
            } else {
              room.imageUrl = null; // Handle cases where image is missing
            }
            return room;
          })
        );
    
        console.log(updatedRooms, 'updatedRooms');
        setPrintData(updatedRooms);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
      let room=printData.map((item)=>item.roomType);
    const roomTypes = room[0]?.split(',')?.map(item => item.trim());
    const handlePost = async () => {
      try {
        setUploading(true);
    
        if (!selectedFile) {
          toast.error("Please select a file to upload.");
          return;
        }
    
        const formData = new FormData();
        formData.append('image', selectedFile); // Ensure 'image' matches the backend field name
    
        const response = await axios.post(
          "https://api.hotel.tdrsoftware.in/upload", // Corrected URL
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          }
        );
    
        const data = response.data;
    
        // Update state with uploaded image URL
        setnewImageURL(data.filename); // Adjust based on backend response
        toast.success("Image uploaded successfully");
        console.log(data, 'Upload response');
      } catch (err) {
        console.error("Upload failed:", err);
        toast.error("Image upload failed. Please try again.");
      } finally {
        setUploading(false);
      }
    };
  //  console.log(newImageURL,'newImageURL')
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;
        setFormData((prevFormData) => ({
          ...prevFormData,
          [name]: checked, // Set formData.halfPlate to true/false based on checkbox state
        }));
      };
      const generateGst=()=>{
        setFormData((prev)=>({
            ...prev,
            sgst:prev.rate*0.025,
            cgst:prev.rate*0.025,
           
            image:newImageURL || prev.image,
        }))
      }
    const handleSubmit=(e)=>{
       
    }
    useEffect(() => {
      fetchData3();
    }, [data]);
    const handleEdit = async (e) => {
      e.preventDefault();
      const updatedFormData = { ...formData, image: newImageURL || formData.image };
    
      try {
        const response = await axios.put(
          `https://api.hotel.tdrsoftware.in/api/updateRoom/${customerId}/${id}?customerId=${customerId}`,
          updatedFormData,{
            headers: {
             Authorization: `Bearer ${token}`,
           },
         } // Send data directly
        );
    
        toast.success(response.data.message);
        console.log(response, 'response');
    
        // Optionally reset the form after a successful update
        setFormData({
          roomNo: "",
          description: "",
          category: "",
          ac: "",
          rate: 0,
          sgst: 0,
          cgst: 0,
          image: "",
          pax: '',
          adult: '',
          child: ''
        });
        window.location.reload();
      } catch (error) {
        toast.error("Error updating room data: " + error.response.data.message);
        console.error("Update failed:", error);
      }
    };
    
    const handleClick=()=>{
      onClose()
      setSelectId(null);
    }
  return (
    <Modal  width='full' size='3xl' isOpen={isOpen} onClose={onClose} onOpen={onOpen} scrollBehavior={scroll}  >
      <ModalOverlay />
      <ModalContent bg='#f9f1e3'>
        <ModalHeader display='flex' justifyContent='space-between' alignItems='center'>
            <Text>Room Data- {data?.roomNo}</Text>
            <Button colorScheme='red' onClick={handleClick} ><IoMdClose/></Button></ModalHeader>
       
        <ModalBody >
         <SimpleGrid columns={2} gap={4} placeItems='left'>
            <InputGroup>
            <InputLeftAddon>RoomNo</InputLeftAddon>
           <Input  bg='white' onChange={handleInputChange} name='roomNo' placeholder='Enter RoomNo' value={formData.roomNo} />
           </InputGroup>
           <InputGroup>
            <InputLeftAddon>Description</InputLeftAddon>
           <Input  bg='white' onChange={handleInputChange} name='description' placeholder='Enter Description' value={formData.description} />
           </InputGroup>
           <InputGroup>
            <InputLeftAddon>Category</InputLeftAddon>
          <Select w='70%' bg='#FAFAFA ' placeholder="Enter Category" name='category' value={formData.category} onChange={handleInputChange}>
                          {roomTypes?.map((item,index)=>(
                            <option key={index} value={item}>{item}</option>
                          ))}
                          </Select>
            
           </InputGroup>
           <InputGroup>
            <InputLeftAddon>AC</InputLeftAddon>
           <Select width='70%'  bg='white' onChange={handleInputChange} name='ac' placeholder='Enter Ac or Non-Ac' value={formData.ac} >
           <option>AC</option>
           <option>Non-AC</option>
           
           </Select>
            
           </InputGroup>
           <InputGroup>
            <InputLeftAddon>Rate</InputLeftAddon>
           <Input  bg='white' onChange={handleInputChange} name='rate' placeholder='Enter Rate' value={formData.rate} />
           </InputGroup>
           
           
          
           <InputGroup> <InputLeftAddon>Sgst Rate</InputLeftAddon>
           <Input  bg='white' onChange={handleInputChange} name='sgst' placeholder='Enter Sgst ' value={formData.sgst} />
           </InputGroup> 
           <InputGroup>
            <InputLeftAddon>Cgst Rate</InputLeftAddon>
           <Input width='68%' bg='white' onChange={handleInputChange} name='cgst' placeholder='Enter Cgst' value={formData.cgst} />
           </InputGroup>
          
            <InputGroup>
                <InputLeftAddon>Image</InputLeftAddon>
                <Input w='70%' type="file" bg='#FAFAFA ' onChange={handleFileChange}  />
                <Button variant='solid' onClick={handlePost} disabled={uploading}>
        {uploading ? "Uploading..." : "Upload"}
      </Button>
                
              </InputGroup>
           
          
          
           

         </SimpleGrid>
         <Box display='flex' alignItems='center' justifyContent='center' gap={4} mt={2}>
         <Button colorScheme='yellow' onClick={generateGst} >Generate Gst</Button>
         <Button colorScheme='green' onClick={(e)=>handleEdit(e)} >Edit</Button>
         </Box>
        </ModalBody>

        <ModalFooter>
         
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default RoomUpdateModal;
